$( document ).ready(function() {
  
  $( ".grid-product__image-mask" ).each(function() {
    let title = $(this).parent().find('.grid-product__title');

    let first_image = $(this).find('.grid__image-ratio.grid__image-ratio--portrait');
    let sizeDiv = $(this).find('.grid-product__size_container');

    if (true) {
      sizeDiv.clone().addClass('mobile--only').appendTo(first_image);
    }
    
  });
});